import { useState, useEffect } from "react";
import "./PeriodicityField.scss";
import Icon from "components/Icon/Icon";
const PeriodicityField = (props: any) => {
  const { defaultValue, editable, label, editPath, onChange, mode }: any = props;
  const [value, setValue] = useState(defaultValue as any);
  const [enabledEdition, setEnabledEdition] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(2);
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  function getDisplayNameByName(name: string) {
    const option = options.find((option: any) => option.name === name);
    return option ? option.displayName : null;
  }
  const options = [
    {
      name: "daily",
      displayName: "Diaria",
    },
    {
      name: "weekly",
      displayName: "Semanal",
    },
    {
      name: "monthly",
      displayName: "Mensual",
    },
    {
      name: "bimonthly",
      displayName: "Bimestral",
    },
    {
      name: "quarterly",
      displayName: "Trimestral",
    },
    {
      name: "four-monthly",
      displayName: "Cuatrimestral",
    },
    {
      name: "semiannually",
      displayName: "Semestral",
    },
    {
      name: "annually",
      displayName: "Anual",
    },
    {
      name: "biennially",
      displayName: "Bianual",
    },
  ];
  const handleSave = () => {
    setEnabledEdition(false);
  };
  const enableEdition = () => {
    setEnabledEdition(true);
  };
  useEffect(() => {
    if (onChange) onChange(value);
  }, [value]);
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  const handleClick = (index: number) => {
    setCurrentIndex(index);
  };
  useEffect(() => {
    setValue(options[currentIndex].name);
  }, [currentIndex]);
  return (
    <div className="periodicity-field-container">
      {label && (
        <label>
          <span>{label}</span>
        </label>
      )}
      <div>
        <div className="field-body">
          <div>
            {mode == 'readonly' ||
              (mode == 'edit' && editable && !isEditEnabled) ||
              (mode == 'edit' && !editable) ? (
              <div className="readonly-content options">

                <span className="actived">{getDisplayNameByName(value)}</span>

              </div>
            ) : (
              <div className="editable-content options">
                {options.map((option: any, index: any) => {
                  return (
                    <a
                      key={index}
                      onClick={() => handleClick(index)}
                      className={value == option.name ? "actived" : ""}
                    >
                      <span>{option?.displayName}</span>
                    </a>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {editable && (
          <div>
            {enabledEdition ? (
              <>
                <button onClick={handleSave}>
                  <Icon name="check" />
                </button>
                <button onClick={() => setEnabledEdition(false)}>
                  <Icon name="close" />
                </button>
              </>
            ) : (
              <>
                <button onClick={enableEdition}>
                  <Icon name="pencil" />
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export { PeriodicityField };
